<template>
<div class="chapter">
<div class="inner_page">
<p class="ded"><span><i>Dedicated to</i></span></p>
<p class="ded1"><span><i>Livingston L. Biddle, Jr</i>.</span></p>
<p class="ded1"><span><i>For his unparalleled contribution to</i></span></p>
<p class="ded1"><span><i>the state of the arts in America</i></span></p>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// dedication.vue?09c3b675